// Role mapping function to convert backend values to display names
export const getRoleDisplayName = (role: string): string => {
    switch (role) {
        case 'client':
            return 'Client';
        case 'property_owner':
            return 'Property Owner';
        case 'real_estate_agency':
            return 'Real Estate Agency';
        default:
            return role; // fallback to original value if unknown
    }
};
